import { OnInit } from "@angular/core";

export class ConstanteCliente {
   id: number;
   nombre: string;
   titulo:string;
   colorTitulo:string;
   descripcion: string;
   fechaI:string;
   fechaF:string;
   version:string;
   archivos:number;
   comentario:number;
   color:string;
   BTP:string;
}

